// icons
import { MdLibraryBooks, MdEngineering, MdBugReport, MdSettings, MdPerson, MdCorporateFare, MdCategory, MdScience, MdAttachMoney, MdDescription } from "react-icons/md";

const catalogos = {
  id: 'catalogos-group',
  type: 'group',
  roles: [1, 100, 110],
  breadcrumbs: false,
  children: [
    {
      id: 'catalogos',
      title: "Catálogos",
      type: 'collapse',
      icon: MdLibraryBooks,
      children: [
        {
          id: 'usuarios-sistema',
          title: "Usuarios de Sistema",
          type: 'item',
          breadcrumbs: false,
          icon: MdPerson,
          url: '/catalogos/usuarios-sistema'
        },
        {
          id: 'tecnicos',
          title: "Técnicos",
          type: 'item',
          breadcrumbs: false,
          icon: MdEngineering,
          url: '/catalogos/tecnicos'
        },
        /*{
          id: 'plagas',
          title: "Plagas",
          type: 'item',
          breadcrumbs: false,
          icon: MdBugReport,
          url: '/catalogos/plagas'
        },*/
        {
          id: 'constantes',
          title: "Constantes",
          type: 'item',
          breadcrumbs: false,
          icon: MdSettings,
          url: '/catalogos/constantes'
        },
        {
          id: 'unidades',
          title: "Unidades",
          type: 'item',
          breadcrumbs: false,
          icon: MdCorporateFare,
          url: '/catalogos/unidades'
        },
        /*{
          id: 'tipos-servicios',
          title: "Tipos de Servicios",
          type: 'item',
          breadcrumbs: false,
          icon: MdCategory,
          url: '/catalogos/tipos-servicios'
        },*/
        /*{
          id: 'dosificaciones',
          title: "Dosificaciones",
          type: 'item',
          breadcrumbs: false,
          icon: MdScience,
          url: '/catalogos/dosificaciones'
        },*/
        {
          id: 'gastos-caja-chica',
          title: "Gastos Caja Chica",
          type: 'item',
          breadcrumbs: false,
          icon: MdAttachMoney,
          url: '/catalogos/gastos-caja-chica'
        },
        {
          id: 'plantillas',
          title: "Plantillas",
          type: 'item',
          breadcrumbs: false,
          icon: MdDescription,
          url: '/catalogos/plantillas'
        }
      ]
    }
  ]
};

export default catalogos;
